import React from "react";

import "./WarningCardStyle.css";

import { FaRegBell } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";

const WarningCard = ({ handleClose }) => {
  return (
    <>
      {/* Toggle Between "warning" and "error" to display alternate styles */}
      <div className="error-card warning">
        <div className="error-card-container">
          <div className="error-card-header">
            <FaRegBell className="icon" />
            <h3 className="error-card-headline">Störungsmeldungen</h3>
            <FaTimes className="icon close" onClick={() => handleClose()} />
          </div>
          <div className="error-card-content">
            <p>Es liegt mindestens eine Störungsmeldung zu diesem Raum vor.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default WarningCard;
